import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import MortgageRemainders from './MortgageRemainders';

type Props = {
  userId: string;
};

export default function ActiveMortgageRemainders({ userId }: Props) {
  const [mortgageId, setMortgageId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    void supabase
      .from('mortgage_accounts')
      .select('id')
      .eq('status', 'active')
      .limit(1)
      .maybeSingle()
      .then(({ data, error: queryError }) => {
        if (!active) return;
        if (queryError || !data) {
          setError('No fue posible identificar el crédito hipotecario activo.');
        } else {
          setMortgageId(data.id);
        }
        setLoading(false);
      });

    return () => { active = false; };
  }, []);

  if (loading) return <section className="remainder-state">Cargando remanentes…</section>;
  if (error || !mortgageId) return <section className="remainder-state">{error || 'No existe una hipoteca activa.'}</section>;
  return <MortgageRemainders mortgageId={mortgageId} userId={userId} />;
}
